import styled from 'styled-components';

import { Typography } from '../../shared/typography';

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 100%;
`;

const LeftContent = styled.div`
	position: relative;
	display: flex;
	flex: 1;
	align-items: center;
	justify-content: center;
`;

const RightContent = styled.div`
	display: flex;
	flex: 1;
	flex-wrap: wrap;
`;

const CenterBox = styled.div`
	position: absolute;
`;

const Title = styled(Typography)`
	font-size: 30px;
	line-height: 35px;

	@media (max-width: 1024px) {
		font-size: 26px;
		line-height: 44px;
	}
`;

const Item = styled.div`
	display: flex;
	align-items: flex-start;
	width: 33%;
	margin-bottom: 6px;

	@media (max-width: 1024px) {
		width: 50%;
	}

	@media (max-width: 768px) {
		width: 100%;
	}
`;

const size = 12;
const Circle = styled.div`
	height: ${size}px;
	min-width: ${size}px;
	border-radius: ${size / 2}px;
	margin-right: 7px;
	align-items: 'flex-start';
	justify-content: 'center';
`;

const Descr = styled(Typography)`
	line-height: 16px;
	padding-right: 20px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Wrapper,
	LeftContent,
	RightContent,
	CenterBox,
	Title,
	Item,
	Circle,
	Descr,
};
